"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _ArticleTopicView = _interopRequireDefault(require("../articles-destination/ArticleTopicView"));

var _TopicFeaturedImage = _interopRequireDefault(require("../topic-list-view/TopicFeaturedImage"));

var _TopicHeader = _interopRequireDefault(require("../topic-list-view/TopicHeader"));

var _classnames = _interopRequireDefault(require("classnames"));

var ArticlePreview = function ArticlePreview(_ref) {
  var topic = _ref.topic;
  return (0, _preact.h)("div", {
    className: "box qa-topic-first-post",
    "data-helper": "class-toggle"
  }, (0, _preact.h)(_TopicHeader.default, {
    title: topic.title,
    contentType: topic.contentType,
    publicLabel: topic.publicLabel,
    replies: 0,
    views: 0
  }), topic.featuredImage ? (0, _preact.h)(_TopicFeaturedImage.default, {
    src: (0, _absoluteUrlRuntime.resolveUrl)(topic.featuredImage),
    alt: topic.featuredImageAltText || topic.title
  }) : (0, _preact.h)("hr", {
    className: (0, _classnames.default)('seperator', 'm-h', 'm-b-0')
  }), (0, _preact.h)(_ArticleTopicView.default, {
    topic: topic,
    isPreview: true,
    currentPage: 1
  }));
};

var _default = ArticlePreview;
exports.default = _default;